import { useLingui } from '@lingui/react/macro';
import { VrpanoOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useAtom } from 'jotai';

import {
  FmxIcon,
  IOCameraWandIcon,
} from '../../../../../common-components/elements/VideaIcons/VideaIcons';

import type { ImageTypes } from './atoms';
import { enabledImageTypesAtom } from './atoms';
import { useGetImageTypes } from './helpers';
import * as Styled from './styles';

export const ImageBrowserFilters = () => {
  const { t } = useLingui();
  const [enabledImageTypes, setEnabledImageTypes] = useAtom(
    enabledImageTypesAtom,
  );
  const imageTypesInBrowser = useGetImageTypes();

  const handleImageFilterChange = (value?: ImageTypes[]) => {
    const imageTypes = !value ? [] : value;
    setEnabledImageTypes(imageTypes);
  };
  return (
    <Styled.ToggleGroup
      className="image-filters"
      orientation="vertical"
      onChange={(_, value) => handleImageFilterChange(value)}
      value={enabledImageTypes}
    >
      {imageTypesInBrowser.fmxPhotos && (
        <Styled.ToggleButtonStyled value="fmxPhotos" className="toggle-height">
          <Tooltip title={t`show/hide FMX images`} placement="right">
            <Styled.IconWrapper className="icon">
              <FmxIcon />
            </Styled.IconWrapper>
          </Tooltip>
        </Styled.ToggleButtonStyled>
      )}
      {imageTypesInBrowser.dentalPhotos && (
        <Styled.ToggleButtonStyled value="dentalPhotos" className="toggle">
          <Tooltip title={t`show/hide all dental photos`} placement="right">
            <Styled.IconWrapper className="icon">
              <IOCameraWandIcon />
            </Styled.IconWrapper>
          </Tooltip>
        </Styled.ToggleButtonStyled>
      )}
      {imageTypesInBrowser.panoPhotos && (
        <Styled.ToggleButtonStyled value="panoPhotos" className="toggle">
          <Tooltip title={t`show/hide pano images`} placement="right">
            <Styled.IconWrapper className="icon">
              <VrpanoOutlined />
            </Styled.IconWrapper>
          </Tooltip>
        </Styled.ToggleButtonStyled>
      )}
    </Styled.ToggleGroup>
  );
};
